import { createClient } from "@supabase/supabase-js";
import indexedDBStorage from "./utils/indexedDBStorage";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

const createNoopQuery = () => {
  const query = {
    select: () => query,
    eq: () => query,
    not: () => query,
    order: () => query,
    in: () => query,
    limit: () => query,
    single: async () => ({ data: null, error: null }),
    maybeSingle: async () => ({ data: null, error: null }),
    insert: async () => ({ data: null, error: null }),
    update: async () => ({ data: null, error: null }),
    upsert: async () => ({ data: null, error: null }),
    delete: async () => ({ data: null, error: null }),
  };

  return query;
};

const createNoopSupabaseClient = () => ({
  auth: {
    getSession: async () => ({ data: { session: null }, error: null }),
    getUser: async () => ({ data: { user: null }, error: null }),
    onAuthStateChange: () => ({
      data: {
        subscription: {
          unsubscribe: () => {},
        },
      },
    }),
    setSession: async () => ({ data: { session: null }, error: null }),
    signInWithPassword: async () => ({ data: { user: null, session: null }, error: null }),
    signOut: async () => ({ error: null }),
  },
  from: () => createNoopQuery(),
  rpc: async () => ({ data: null, error: null }),
  channel: () => ({
    subscribe: () => ({
      unsubscribe: () => {},
    }),
    unsubscribe: () => {},
  }),
  removeChannel: async () => null,
  storage: {
    from: () => ({
      upload: async () => ({ data: null, error: null }),
      download: async () => ({ data: null, error: null }),
      remove: async () => ({ data: null, error: null }),
      list: async () => ({ data: [], error: null }),
      getPublicUrl: () => ({ data: { publicUrl: null } }),
    }),
  },
});

// Единственный экземпляр клиента для всего приложения
export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: "implicit",
        storage: indexedDBStorage,
        storageKey: "mgfood-auth-token", // Явный ключ для консистентного хранения
      },
      global: {
        headers: {
          "x-application-name": "school-nutrition-app",
        },
      },
      db: {
        schema: "public",
      },
      realtime: {
        params: {
          eventsPerSecond: 10,
        },
      },
    })
  : createNoopSupabaseClient();

export const supabaseAuth = supabase.auth;

// Утилита для безопасного выполнения запросов
export const safeSupabaseCall = async (callFn) => {
  const { data, error } = await callFn();
  if (error) throw error;
  return data;
};

export default supabase;
